var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":_vm.width,"height":_vm.height,"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('circle',{class:`fill-${_vm.color}`,attrs:{"cx":_vm.width/2,"cy":_vm.height/2,"r":_vm.width/2}}),_c('path',{attrs:{"d":"M5.2347 8.26521L7.11116 10.0126L11.2777 5.62094","stroke":"white","stroke-linecap":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }